import { useToast } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import * as ReportingsApi from '@Modules/reporting/api/reportingsApi';
import { CardByPrepaidAndStatusFormUI } from '@Modules/reporting/components/forms/cardManagementSystem/prepaid/CardByPrepaidAndStatusFormUI';
import PrepaidMeta from './CardByPrepaidAndStatusMeta';

export default function CardByPrepaidAndStatusFormHandle() {
  const toast = useToast();
  
  const { mutateAsync, isLoading: isSubmitting } = useMutation( ReportingsApi.printTransactions, {
    onSuccess: (data) => {
      // console.log('Response: ', data);
      toast({
        position: 'top-right',
        title: 'Lorem ipsum dolor sit amet.',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error) => {
      console.log('Error: ', error);
    },
  });
  
  const onSubmit = (payload: any) => {

    mutateAsync(payload)
    
    console.log('payload: ', payload);
  };

  return (
    <>
      <CardByPrepaidAndStatusFormUI
        isSubmitting={isSubmitting}
        meta={PrepaidMeta}
        onSubmit={onSubmit}
      />
    </>
  );
}
